import React, { useEffect, useState } from 'react';
import { Container } from 'components/Page';
import { Formik, Field, Form } from 'formik';
import { api } from 'app';
import BaseAlert from 'packages/ui/Alert';
import { FormGroup, FormControl, Label } from 'components/form/Formik';
import Button from 'packages/ui/Button';
import Select from 'react-select';

export default ({ virgoolId }) => {
  const [initialData, setInitialData] = useState({
    event_id: '',
    button_text: '',
    title: '',
    link: '_EVENT_LINK_',
    cover: '',
    tags: '',
    count: '',
    topics: '',
    sendToVirgool: false
  });
  const [submittingMsg, setSubmittingMsg] = useState();
  const [categories, setCategories] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [sendToVirgool, setSendToVirgool] = useState(false);

  const fetchCategories = async () => {
    let arr = await api.get('categories');
    let cats = [];
    if (arr.body.data.length > 0) {
      arr.body.data.forEach(cat => {
        cats.push({
          label: cat.title,
          value: cat.id
        });
      });
      setCategories(cats);
    }
    return cats;
  };

  const fetchVirgoolData = async () => {
    const cats = await fetchCategories();
    if (virgoolId !== 'create') {
      api.get(`/virgool-advertises/${virgoolId}`).then(res => {
        setInitialData({
          event_id: res.body.data.event_id,
          button_text: res.body.data.button_text,
          title: res.body.data.title,
          link: res.body.data.link,
          cover: res.body.data.cover,
          count: res.body.data.count,
          tags: res.body.data.tags,
          topics: res.body.data.topics,
          sendToVirgool: false
        });
        setLoading(false);
        setSelectedTopics(cats.filter(option => res.body.data.topics.includes(option.value)));
      });
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVirgoolData();
  }, []);

  const saveData = values => {
    let topics = selectedTopics.map(topic => topic.value);
    if (typeof topics === 'string') {
      topics = topics.split(',').filter(i => i);
    }

    let tags = values.tags;
    if (typeof tags === 'string') {
      tags = tags.split(',').filter(i => i);
    }

    const payload = {
      event_id: values.event_id,
      title: values.title,
      button_text: values.button_text,
      cover: values.cover,
      count: Number(values.count),
      link: values.link,
      topics: topics,
      tags: tags
    };

    if (virgoolId === 'create') {
      payload.data = {
        virgool: {
          count: payload.count,
          title: payload.title,
          button_text: payload.button_text,
          targeting: {
            categories: payload.topics
          }
        }
      };
    }

    const endpoint =
      virgoolId === 'create' ? '/virgool-advertises' : `/virgool-advertises/${virgoolId}`;
    const method = virgoolId === 'create' ? api.post : api.put;

    return method(endpoint, {
      ...payload
    }).then(response => response.json());
  };

  if (!loading) {
    return (
      <Container>
        <div>
          <h1>لطفا فرم زیر را تکمیل کنید</h1>
          <Formik
            initialValues={{
              ...initialData
            }}
            onSubmit={async (values, actions) => {
              actions.setSubmitting(true);
              try {
                const response = await saveData(values);
                if (values.sendToVirgool) {
                  api
                    .get(`virgool-advertises/${response.data.id}/request-to-virgool`)
                    .then(() => {
                      setSubmittingMsg('درخواست شما با موفقیت در ویرگرول ثبت گردید.');
                    })
                    .catch(err => {
                      console.log(err);
                      setSubmittingMsg(err.error.message);
                    });
                } else {
                  setSubmittingMsg('درخواست شما با موفقیت ثبت گردید.');
                }
              } catch (err) {
                console.log(err);
                // setSubmittingMsg(Object.values(err.errors)[0][0]);
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {({ setFieldValue }) => {
              return (
                <Form>
                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="event-id">آی دی رویداد</Label>
                      <Field id="event-id" name="event_id" type="text" />
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="button-text">متن کال تو اکشن</Label>
                      <Field id="button-text" name="button_text" placeholder="" type="text" />
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="title">عنوان نمایش سفارش</Label>
                      <Field id="title" name="title" placeholder="" type="text" />
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="tags">تگ‌ها</Label>
                      <Field
                        id="tags"
                        name="tags"
                        placeholder="نمونه: سرگرمی, تلویزیون, بازی"
                        type="text"
                      />
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="cover">لینک کاور</Label>
                      <Field id="cover" name="cover" placeholder="" type="text" />
                      <p>به صورت اتوماتیک لینک کاور قرار می‌گیرد</p>
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="link">لینک کال تو اکشن</Label>
                      <Field id="link" name="link" placeholder="" type="text" />
                      <p>_EVENT_LINK_ لینک رویداد همراه با UTM و کد تخفیف</p>
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="count">تعداد نمایش (ایمپرشن)</Label>
                      <Field id="count" name="count" type="text" />
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="topics">دسته‌بندی در ایوند</Label>
                      <Field
                        id="topics"
                        name="topics"
                        component={Select}
                        options={categories}
                        isMulti
                        placeholder="انتخاب کنید"
                        type="text"
                        value={selectedTopics}
                        onChange={e => setSelectedTopics(e)}
                      />
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <Button mood="secondary" type="submit" style={{ marginLeft: '25px' }}>
                      ذخیره
                    </Button>
                    <Button
                      mood="primary"
                      type="submit"
                      onClick={() => setFieldValue('sendToVirgool', true)}
                    >
                      ذخیره و نمایش در ویرگول
                    </Button>
                  </FormGroup>

                  {submittingMsg && (
                    <BaseAlert mood="info" title={submittingMsg}>
                      {submittingMsg}
                    </BaseAlert>
                  )}
                </Form>
              );
            }}
          </Formik>
        </div>
      </Container>
    );
  } else {
    return null;
  }
};
